export const timeZones = [
  "Africa/Abidjan",
  "Africa/Accra",
  "Africa/Addis_Ababa",
  "Africa/Algiers",
  "Africa/Asmara",
  "Africa/Asmera",
  "Africa/Bamako",
  "Africa/Bangui",
  "Africa/Banjul",
  "Africa/Bissau",
  "Africa/Blantyre",
  "Africa/Brazzaville",
  "Africa/Bujumbura",
  "Africa/Cairo",
  "Africa/Casablanca",
  "Africa/Ceuta",
  "Africa/Conakry",
  "Africa/Dakar",
  "Africa/Dar_es_Salaam",
  "Africa/Djibouti",
  "Africa/Douala",
  "Africa/El_Aaiun",
  "Africa/Freetown",
  "Africa/Gaborone",
  "Africa/Harare",
  "Africa/Johannesburg",
  "Africa/Juba",
  "Africa/Kampala",
  "Africa/Khartoum",
  "Africa/Kigali",
  "Africa/Kinshasa",
  "Africa/Lagos",
  "Africa/Libreville",
  "Africa/Lome",
  "Africa/Luanda",
  "Africa/Lubumbashi",
  "Africa/Lusaka",
  "Africa/Malabo",
  "Africa/Maputo",
  "Africa/Maseru",
  "Africa/Mbabane",
  "Africa/Mogadishu",
  "Africa/Monrovia",
  "Africa/Nairobi",
  "Africa/Ndjamena",
  "Africa/Niamey",
  "Africa/Nouakchott",
  "Africa/Ouagadougou",
  "Africa/Porto-Novo",
  "Africa/Sao_Tome",
  "Africa/Timbuktu",
  "Africa/Tripoli",
  "Africa/Tunis",
  "Africa/Windhoek",
  "America/Adak",
  "America/Anchorage",
  "America/Anguilla",
  "America/Antigua",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/ComodRivadavia",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Aruba",
  "America/Asuncion",
  "America/Atikokan",
  "America/Atka",
  "America/Bahia",
  "America/Bahia_Banderas",
  "America/Barbados",
  "America/Belem",
  "America/Belize",
  "America/Blanc-Sablon",
  "America/Boa_Vista",
  "America/Bogota",
  "America/Boise",
  "America/Buenos_Aires",
  "America/Cambridge_Bay",
  "America/Campo_Grande",
  "America/Cancun",
  "America/Caracas",
  "America/Catamarca",
  "America/Cayenne",
  "America/Cayman",
  "America/Chicago",
  "America/Chihuahua",
  "America/Coral_Harbour",
  "America/Cordoba",
  "America/Costa_Rica",
  "America/Creston",
  "America/Cuiaba",
  "America/Curacao",
  "America/Danmarkshavn",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Denver",
  "America/Detroit",
  "America/Dominica",
  "America/Edmonton",
  "America/Eirunepe",
  "America/El_Salvador",
  "America/Ensenada",
  "America/Fort_Nelson",
  "America/Fort_Wayne",
  "America/Fortaleza",
  "America/Glace_Bay",
  "America/Godthab",
  "America/Goose_Bay",
  "America/Grand_Turk",
  "America/Grenada",
  "America/Guadeloupe",
  "America/Guatemala",
  "America/Guayaquil",
  "America/Guyana",
  "America/Halifax",
  "America/Havana",
  "America/Hermosillo",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Indianapolis",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Jamaica",
  "America/Jujuy",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Knox_IN",
  "America/Kralendijk",
  "America/La_Paz",
  "America/Lima",
  "America/Los_Angeles",
  "America/Louisville",
  "America/Lower_Princes",
  "America/Maceio",
  "America/Managua",
  "America/Manaus",
  "America/Marigot",
  "America/Martinique",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Mendoza",
  "America/Menominee",
  "America/Merida",
  "America/Metlakatla",
  "America/Mexico_City",
  "America/Miquelon",
  "America/Moncton",
  "America/Monterrey",
  "America/Montevideo",
  "America/Montreal",
  "America/Montserrat",
  "America/Nassau",
  "America/New_York",
  "America/Nipigon",
  "America/Nome",
  "America/Noronha",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Ojinaga",
  "America/Panama",
  "America/Pangnirtung",
  "America/Paramaribo",
  "America/Phoenix",
  "America/Port-au-Prince",
  "America/Port_of_Spain",
  "America/Porto_Acre",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Punta_Arenas",
  "America/Rainy_River",
  "America/Rankin_Inlet",
  "America/Recife",
  "America/Regina",
  "America/Resolute",
  "America/Rio_Branco",
  "America/Rosario",
  "America/Santa_Isabel",
  "America/Santarem",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Sao_Paulo",
  "America/Scoresbysund",
  "America/Shiprock",
  "America/Sitka",
  "America/St_Barthelemy",
  "America/St_Johns",
  "America/St_Kitts",
  "America/St_Lucia",
  "America/St_Thomas",
  "America/St_Vincent",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "America/Thule",
  "America/Thunder_Bay",
  "America/Tijuana",
  "America/Toronto",
  "America/Tortola",
  "America/Vancouver",
  "America/Virgin",
  "America/Whitehorse",
  "America/Winnipeg",
  "America/Yakutat",
  "America/Yellowknife",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville",
  "Antarctica/Macquarie",
  "Antarctica/Mawson",
  "Antarctica/McMurdo",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/South_Pole",
  "Antarctica/Syowa",
  "Antarctica/Troll",
  "Antarctica/Vostok",
  "Arctic/Longyearbyen",
  "Asia/Aden",
  "Asia/Almaty",
  "Asia/Amman",
  "Asia/Anadyr",
  "Asia/Aqtau",
  "Asia/Aqtobe",
  "Asia/Ashgabat",
  "Asia/Ashkhabad",
  "Asia/Atyrau",
  "Asia/Baghdad",
  "Asia/Bahrain",
  "Asia/Baku",
  "Asia/Bangkok",
  "Asia/Barnaul",
  "Asia/Beirut",
  "Asia/Bishkek",
  "Asia/Brunei",
  "Asia/Calcutta",
  "Asia/Chita",
  "Asia/Choibalsan",
  "Asia/Chongqing",
  "Asia/Chungking",
  "Asia/Colombo",
  "Asia/Dacca",
  "Asia/Damascus",
  "Asia/Dhaka",
  "Asia/Dili",
  "Asia/Dubai",
  "Asia/Dushanbe",
  "Asia/Famagusta",
  "Asia/Gaza",
  "Asia/Harbin",
  "Asia/Hebron",
  "Asia/Ho_Chi_Minh",
  "Asia/Hong_Kong",
  "Asia/Hovd",
  "Asia/Irkutsk",
  "Asia/Istanbul",
  "Asia/Jakarta",
  "Asia/Jayapura",
  "Asia/Jerusalem",
  "Asia/Kabul",
  "Asia/Kamchatka",
  "Asia/Karachi",
  "Asia/Kashgar",
  "Asia/Kathmandu",
  "Asia/Katmandu",
  "Asia/Khandyga",
  "Asia/Kolkata",
  "Asia/Krasnoyarsk",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Asia/Kuwait",
  "Asia/Macao",
  "Asia/Macau",
  "Asia/Magadan",
  "Asia/Makassar",
  "Asia/Manila",
  "Asia/Muscat",
  "Asia/Nicosia",
  "Asia/Novokuznetsk",
  "Asia/Novosibirsk",
  "Asia/Omsk",
  "Asia/Oral",
  "Asia/Phnom_Penh",
  "Asia/Pontianak",
  "Asia/Pyongyang",
  "Asia/Qatar",
  "Asia/Qostanay",
  "Asia/Qyzylorda",
  "Asia/Rangoon",
  "Asia/Riyadh",
  "Asia/Saigon",
  "Asia/Sakhalin",
  "Asia/Samarkand",
  "Asia/Seoul",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Srednekolymsk",
  "Asia/Taipei",
  "Asia/Tashkent",
  "Asia/Tbilisi",
  "Asia/Tehran",
  "Asia/Tel_Aviv",
  "Asia/Thimbu",
  "Asia/Thimphu",
  "Asia/Tokyo",
  "Asia/Tomsk",
  "Asia/Ujung_Pandang",
  "Asia/Ulaanbaatar",
  "Asia/Ulan_Bator",
  "Asia/Urumqi",
  "Asia/Ust-Nera",
  "Asia/Vientiane",
  "Asia/Vladivostok",
  "Asia/Yakutsk",
  "Asia/Yangon",
  "Asia/Yekaterinburg",
  "Asia/Yerevan",
  "Atlantic/Azores",
  "Atlantic/Bermuda",
  "Atlantic/Canary",
  "Atlantic/Cape_Verde",
  "Atlantic/Faeroe",
  "Atlantic/Faroe",
  "Atlantic/Jan_Mayen",
  "Atlantic/Madeira",
  "Atlantic/Reykjavik",
  "Atlantic/South_Georgia",
  "Atlantic/St_Helena",
  "Atlantic/Stanley",
  "Australia/ACT",
  "Australia/Adelaide",
  "Australia/Brisbane",
  "Australia/Broken_Hill",
  "Australia/Canberra",
  "Australia/Currie",
  "Australia/Darwin",
  "Australia/Eucla",
  "Australia/Hobart",
  "Australia/LHI",
  "Australia/Lindeman",
  "Australia/Lord_Howe",
  "Australia/Melbourne",
  "Australia/NSW",
  "Australia/North",
  "Australia/Perth",
  "Australia/Queensland",
  "Australia/South",
  "Australia/Sydney",
  "Australia/Tasmania",
  "Australia/Victoria",
  "Australia/West",
  "Australia/Yancowinna",
  "Brazil/Acre",
  "Brazil/DeNoronha",
  "Brazil/East",
  "Brazil/West",
  "CET",
  "CST6CDT",
  "Canada/Atlantic",
  "Canada/Central",
  "Canada/Eastern",
  "Canada/Mountain",
  "Canada/Newfoundland",
  "Canada/Pacific",
  "Canada/Saskatchewan",
  "Canada/Yukon",
  "Chile/Continental",
  "Chile/EasterIsland",
  "Cuba",
  "EET",
  "EST",
  "EST5EDT",
  "Egypt",
  "Eire",
  "Etc/GMT",
  "Etc/GMT+0",
  "Etc/GMT+1",
  "Etc/GMT+10",
  "Etc/GMT+11",
  "Etc/GMT+12",
  "Etc/GMT+2",
  "Etc/GMT+3",
  "Etc/GMT+4",
  "Etc/GMT+5",
  "Etc/GMT+6",
  "Etc/GMT+7",
  "Etc/GMT+8",
  "Etc/GMT+9",
  "Etc/GMT-0",
  "Etc/GMT-1",
  "Etc/GMT-10",
  "Etc/GMT-11",
  "Etc/GMT-12",
  "Etc/GMT-13",
  "Etc/GMT-14",
  "Etc/GMT-2",
  "Etc/GMT-3",
  "Etc/GMT-4",
  "Etc/GMT-5",
  "Etc/GMT-6",
  "Etc/GMT-7",
  "Etc/GMT-8",
  "Etc/GMT-9",
  "Etc/GMT0",
  "Etc/Greenwich",
  "Etc/UCT",
  "Etc/UTC",
  "Etc/Universal",
  "Etc/Zulu",
  "Europe/Amsterdam",
  "Europe/Andorra",
  "Europe/Astrakhan",
  "Europe/Athens",
  "Europe/Belfast",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Bratislava",
  "Europe/Brussels",
  "Europe/Bucharest",
  "Europe/Budapest",
  "Europe/Busingen",
  "Europe/Chisinau",
  "Europe/Copenhagen",
  "Europe/Dublin",
  "Europe/Gibraltar",
  "Europe/Guernsey",
  "Europe/Helsinki",
  "Europe/Isle_of_Man",
  "Europe/Istanbul",
  "Europe/Jersey",
  "Europe/Kaliningrad",
  "Europe/Kiev",
  "Europe/Kirov",
  "Europe/Lisbon",
  "Europe/Ljubljana",
  "Europe/London",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Malta",
  "Europe/Mariehamn",
  "Europe/Minsk",
  "Europe/Monaco",
  "Europe/Moscow",
  "Europe/Nicosia",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Podgorica",
  "Europe/Prague",
  "Europe/Riga",
  "Europe/Rome",
  "Europe/Samara",
  "Europe/San_Marino",
  "Europe/Sarajevo",
  "Europe/Saratov",
  "Europe/Simferopol",
  "Europe/Skopje",
  "Europe/Sofia",
  "Europe/Stockholm",
  "Europe/Tallinn",
  "Europe/Tirane",
  "Europe/Tiraspol",
  "Europe/Ulyanovsk",
  "Europe/Uzhgorod",
  "Europe/Vaduz",
  "Europe/Vatican",
  "Europe/Vienna",
  "Europe/Vilnius",
  "Europe/Volgograd",
  "Europe/Warsaw",
  "Europe/Zagreb",
  "Europe/Zaporozhye",
  "Europe/Zurich",
  "GB",
  "GB-Eire",
  "GMT",
  "GMT+0",
  "GMT-0",
  "GMT0",
  "Greenwich",
  "HST",
  "Hongkong",
  "Iceland",
  "Indian/Antananarivo",
  "Indian/Chagos",
  "Indian/Christmas",
  "Indian/Cocos",
  "Indian/Comoro",
  "Indian/Kerguelen",
  "Indian/Mahe",
  "Indian/Maldives",
  "Indian/Mauritius",
  "Indian/Mayotte",
  "Indian/Reunion",
  "Iran",
  "Israel",
  "Jamaica",
  "Japan",
  "Kwajalein",
  "Libya",
  "MET",
  "MST",
  "MST7MDT",
  "Mexico/BajaNorte",
  "Mexico/BajaSur",
  "Mexico/General",
  "NZ",
  "NZ-CHAT",
  "Navajo",
  "PRC",
  "PST8PDT",
  "Pacific/Apia",
  "Pacific/Auckland",
  "Pacific/Bougainville",
  "Pacific/Chatham",
  "Pacific/Chuuk",
  "Pacific/Easter",
  "Pacific/Efate",
  "Pacific/Enderbury",
  "Pacific/Fakaofo",
  "Pacific/Fiji",
  "Pacific/Funafuti",
  "Pacific/Galapagos",
  "Pacific/Gambier",
  "Pacific/Guadalcanal",
  "Pacific/Guam",
  "Pacific/Honolulu",
  "Pacific/Johnston",
  "Pacific/Kiritimati",
  "Pacific/Kosrae",
  "Pacific/Kwajalein",
  "Pacific/Majuro",
  "Pacific/Marquesas",
  "Pacific/Midway",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Norfolk",
  "Pacific/Noumea",
  "Pacific/Pago_Pago",
  "Pacific/Palau",
  "Pacific/Pitcairn",
  "Pacific/Pohnpei",
  "Pacific/Ponape",
  "Pacific/Port_Moresby",
  "Pacific/Rarotonga",
  "Pacific/Saipan",
  "Pacific/Samoa",
  "Pacific/Tahiti",
  "Pacific/Tarawa",
  "Pacific/Tongatapu",
  "Pacific/Truk",
  "Pacific/Wake",
  "Pacific/Wallis",
  "Pacific/Yap",
  "Poland",
  "Portugal",
  "ROC",
  "ROK",
  "Singapore",
  "Turkey",
  "UCT",
  "US/Alaska",
  "US/Aleutian",
  "US/Arizona",
  "US/Central",
  "US/East-Indiana",
  "US/Eastern",
  "US/Hawaii",
  "US/Indiana-Starke",
  "US/Michigan",
  "US/Mountain",
  "US/Pacific",
  "US/Samoa",
  "UTC",
  "Universal",
  "W-SU",
  "WET",
  "Zulu",
];

export const CommonTimezones = [
  {value: "Africa/Abidjan", label: "Africa/Abidjan", text: "Africa/Abidjan"},
  {value: "Africa/Accra", label: "Africa/Accra", text: "Africa/Accra"},
  {value: "Africa/Addis_Ababa", label: "Africa/Addis_Ababa", text: "Africa/Addis_Ababa"},
  {value: "Africa/Algiers", label: "Africa/Algiers", text: "Africa/Algiers"},
  {value: "Africa/Asmara", label: "Africa/Asmara", text: "Africa/Asmara"},
  {value: "Africa/Bamako", label: "Africa/Bamako", text: "Africa/Bamako"},
  {value: "Africa/Bangui", label: "Africa/Bangui", text: "Africa/Bangui"},
  {value: "Africa/Banjul", label: "Africa/Banjul", text: "Africa/Banjul"},
  {value: "Africa/Bissau", label: "Africa/Bissau", text: "Africa/Bissau"},
  {value: "Africa/Blantyre", label: "Africa/Blantyre", text: "Africa/Blantyre"},
  {value: "Africa/Brazzaville", label: "Africa/Brazzaville", text: "Africa/Brazzaville"},
  {value: "Africa/Bujumbura", label: "Africa/Bujumbura", text: "Africa/Bujumbura"},
  {value: "Africa/Cairo", label: "Africa/Cairo", text: "Africa/Cairo"},
  {value: "Africa/Casablanca", label: "Africa/Casablanca", text: "Africa/Casablanca"},
  {value: "Africa/Ceuta", label: "Africa/Ceuta", text: "Africa/Ceuta"},
  {value: "Africa/Conakry", label: "Africa/Conakry", text: "Africa/Conakry"},
  {value: "Africa/Dakar", label: "Africa/Dakar", text: "Africa/Dakar"},
  {value: "Africa/Dar_es_Salaam", label: "Africa/Dar_es_Salaam", text: "Africa/Dar_es_Salaam"},
  {value: "Africa/Djibouti", label: "Africa/Djibouti", text: "Africa/Djibouti"},
  {value: "Africa/Douala", label: "Africa/Douala", text: "Africa/Douala"},
  {value: "Africa/El_Aaiun", label: "Africa/El_Aaiun", text: "Africa/El_Aaiun"},
  {value: "Africa/Freetown", label: "Africa/Freetown", text: "Africa/Freetown"},
  {value: "Africa/Gaborone", label: "Africa/Gaborone", text: "Africa/Gaborone"},
  {value: "Africa/Harare", label: "Africa/Harare", text: "Africa/Harare"},
  {value: "Africa/Johannesburg", label: "Africa/Johannesburg", text: "Africa/Johannesburg"},
  {value: "Africa/Juba", label: "Africa/Juba", text: "Africa/Juba"},
  {value: "Africa/Kampala", label: "Africa/Kampala", text: "Africa/Kampala"},
  {value: "Africa/Khartoum", label: "Africa/Khartoum", text: "Africa/Khartoum"},
  {value: "Africa/Kigali", label: "Africa/Kigali", text: "Africa/Kigali"},
  {value: "Africa/Kinshasa", label: "Africa/Kinshasa", text: "Africa/Kinshasa"},
  {value: "Africa/Lagos", label: "Africa/Lagos", text: "Africa/Lagos"},
  {value: "Africa/Libreville", label: "Africa/Libreville", text: "Africa/Libreville"},
  {value: "Africa/Lome", label: "Africa/Lome", text: "Africa/Lome"},
  {value: "Africa/Luanda", label: "Africa/Luanda", text: "Africa/Luanda"},
  {value: "Africa/Lubumbashi", label: "Africa/Lubumbashi", text: "Africa/Lubumbashi"},
  {value: "Africa/Lusaka", label: "Africa/Lusaka", text: "Africa/Lusaka"},
  {value: "Africa/Malabo", label: "Africa/Malabo", text: "Africa/Malabo"},
  {value: "Africa/Maputo", label: "Africa/Maputo", text: "Africa/Maputo"},
  {value: "Africa/Maseru", label: "Africa/Maseru", text: "Africa/Maseru"},
  {value: "Africa/Mbabane", label: "Africa/Mbabane", text: "Africa/Mbabane"},
  {value: "Africa/Mogadishu", label: "Africa/Mogadishu", text: "Africa/Mogadishu"},
  {value: "Africa/Monrovia", label: "Africa/Monrovia", text: "Africa/Monrovia"},
  {value: "Africa/Nairobi", label: "Africa/Nairobi", text: "Africa/Nairobi"},
  {value: "Africa/Ndjamena", label: "Africa/Ndjamena", text: "Africa/Ndjamena"},
  {value: "Africa/Niamey", label: "Africa/Niamey", text: "Africa/Niamey"},
  {value: "Africa/Nouakchott", label: "Africa/Nouakchott", text: "Africa/Nouakchott"},
  {value: "Africa/Ouagadougou", label: "Africa/Ouagadougou", text: "Africa/Ouagadougou"},
  {value: "Africa/Porto-Novo", label: "Africa/Porto-Novo", text: "Africa/Porto-Novo"},
  {value: "Africa/Sao_Tome", label: "Africa/Sao_Tome", text: "Africa/Sao_Tome"},
  {value: "Africa/Tripoli", label: "Africa/Tripoli", text: "Africa/Tripoli"},
  {value: "Africa/Tunis", label: "Africa/Tunis", text: "Africa/Tunis"},
  {value: "Africa/Windhoek", label: "Africa/Windhoek", text: "Africa/Windhoek"},
  {value: "America/Adak", label: "America/Adak", text: "America/Adak"},
  {value: "America/Anchorage", label: "America/Anchorage", text: "America/Anchorage"},
  {value: "America/Anguilla", label: "America/Anguilla", text: "America/Anguilla"},
  {value: "America/Antigua", label: "America/Antigua", text: "America/Antigua"},
  {value: "America/Araguaina", label: "America/Araguaina", text: "America/Araguaina"},
  {value: "America/Argentina/Buenos_Aires", label: "America/Argentina/Buenos_Aires", text: "America/Argentina/Buenos_Aires"},
  {value: "America/Argentina/Catamarca", label: "America/Argentina/Catamarca", text: "America/Argentina/Catamarca"},
  {value: "America/Argentina/Cordoba", label: "America/Argentina/Cordoba", text: "America/Argentina/Cordoba"},
  {value: "America/Argentina/Jujuy", label: "America/Argentina/Jujuy", text: "America/Argentina/Jujuy"},
  {value: "America/Argentina/La_Rioja", label: "America/Argentina/La_Rioja", text: "America/Argentina/La_Rioja"},
  {value: "America/Argentina/Mendoza", label: "America/Argentina/Mendoza", text: "America/Argentina/Mendoza"},
  {value: "America/Argentina/Rio_Gallegos", label: "America/Argentina/Rio_Gallegos", text: "America/Argentina/Rio_Gallegos"},
  {value: "America/Argentina/Salta", label: "America/Argentina/Salta", text: "America/Argentina/Salta"},
  {value: "America/Argentina/San_Juan", label: "America/Argentina/San_Juan", text: "America/Argentina/San_Juan"},
  {value: "America/Argentina/San_Luis", label: "America/Argentina/San_Luis", text: "America/Argentina/San_Luis"},
  {value: "America/Argentina/Tucuman", label: "America/Argentina/Tucuman", text: "America/Argentina/Tucuman"},
  {value: "America/Argentina/Ushuaia", label: "America/Argentina/Ushuaia", text: "America/Argentina/Ushuaia"},
  {value: "America/Aruba", label: "America/Aruba", text: "America/Aruba"},
  {value: "America/Asuncion", label: "America/Asuncion", text: "America/Asuncion"},
  {value: "America/Atikokan", label: "America/Atikokan", text: "America/Atikokan"},
  {value: "America/Bahia", label: "America/Bahia", text: "America/Bahia"},
  {value: "America/Bahia_Banderas", label: "America/Bahia_Banderas", text: "America/Bahia_Banderas"},
  {value: "America/Barbados", label: "America/Barbados", text: "America/Barbados"},
  {value: "America/Belem", label: "America/Belem", text: "America/Belem"},
  {value: "America/Belize", label: "America/Belize", text: "America/Belize"},
  {value: "America/Blanc-Sablon", label: "America/Blanc-Sablon", text: "America/Blanc-Sablon"},
  {value: "America/Boa_Vista", label: "America/Boa_Vista", text: "America/Boa_Vista"},
  {value: "America/Bogota", label: "America/Bogota", text: "America/Bogota"},
  {value: "America/Boise", label: "America/Boise", text: "America/Boise"},
  {value: "America/Cambridge_Bay", label: "America/Cambridge_Bay", text: "America/Cambridge_Bay"},
  {value: "America/Campo_Grande", label: "America/Campo_Grande", text: "America/Campo_Grande"},
  {value: "America/Cancun", label: "America/Cancun", text: "America/Cancun"},
  {value: "America/Caracas", label: "America/Caracas", text: "America/Caracas"},
  {value: "America/Cayenne", label: "America/Cayenne", text: "America/Cayenne"},
  {value: "America/Cayman", label: "America/Cayman", text: "America/Cayman"},
  {value: "America/Chicago", label: "America/Chicago", text: "America/Chicago"},
  {value: "America/Chihuahua", label: "America/Chihuahua", text: "America/Chihuahua"},
  {value: "America/Costa_Rica", label: "America/Costa_Rica", text: "America/Costa_Rica"},
  {value: "America/Creston", label: "America/Creston", text: "America/Creston"},
  {value: "America/Cuiaba", label: "America/Cuiaba", text: "America/Cuiaba"},
  {value: "America/Curacao", label: "America/Curacao", text: "America/Curacao"},
  {value: "America/Danmarkshavn", label: "America/Danmarkshavn", text: "America/Danmarkshavn"},
  {value: "America/Dawson", label: "America/Dawson", text: "America/Dawson"},
  {value: "America/Dawson_Creek", label: "America/Dawson_Creek", text: "America/Dawson_Creek"},
  {value: "America/Denver", label: "America/Denver", text: "America/Denver"},
  {value: "America/Detroit", label: "America/Detroit", text: "America/Detroit"},
  {value: "America/Dominica", label: "America/Dominica", text: "America/Dominica"},
  {value: "America/Edmonton", label: "America/Edmonton", text: "America/Edmonton"},
  {value: "America/Eirunepe", label: "America/Eirunepe", text: "America/Eirunepe"},
  {value: "America/El_Salvador", label: "America/El_Salvador", text: "America/El_Salvador"},
  {value: "America/Fort_Nelson", label: "America/Fort_Nelson", text: "America/Fort_Nelson"},
  {value: "America/Fortaleza", label: "America/Fortaleza", text: "America/Fortaleza"},
  {value: "America/Glace_Bay", label: "America/Glace_Bay", text: "America/Glace_Bay"},
  {value: "America/Godthab", label: "America/Godthab", text: "America/Godthab"},
  {value: "America/Goose_Bay", label: "America/Goose_Bay", text: "America/Goose_Bay"},
  {value: "America/Grand_Turk", label: "America/Grand_Turk", text: "America/Grand_Turk"},
  {value: "America/Grenada", label: "America/Grenada", text: "America/Grenada"},
  {value: "America/Guadeloupe", label: "America/Guadeloupe", text: "America/Guadeloupe"},
  {value: "America/Guatemala", label: "America/Guatemala", text: "America/Guatemala"},
  {value: "America/Guayaquil", label: "America/Guayaquil", text: "America/Guayaquil"},
  {value: "America/Guyana", label: "America/Guyana", text: "America/Guyana"},
  {value: "America/Halifax", label: "America/Halifax", text: "America/Halifax"},
  {value: "America/Havana", label: "America/Havana", text: "America/Havana"},
  {value: "America/Hermosillo", label: "America/Hermosillo", text: "America/Hermosillo"},
  {value: "America/Indiana/Indianapolis", label: "America/Indiana/Indianapolis", text: "America/Indiana/Indianapolis"},
  {value: "America/Indiana/Knox", label: "America/Indiana/Knox", text: "America/Indiana/Knox"},
  {value: "America/Indiana/Marengo", label: "America/Indiana/Marengo", text: "America/Indiana/Marengo"},
  {value: "America/Indiana/Petersburg", label: "America/Indiana/Petersburg", text: "America/Indiana/Petersburg"},
  {value: "America/Indiana/Tell_City", label: "America/Indiana/Tell_City", text: "America/Indiana/Tell_City"},
  {value: "America/Indiana/Vevay", label: "America/Indiana/Vevay", text: "America/Indiana/Vevay"},
  {value: "America/Indiana/Vincennes", label: "America/Indiana/Vincennes", text: "America/Indiana/Vincennes"},
  {value: "America/Indiana/Winamac", label: "America/Indiana/Winamac", text: "America/Indiana/Winamac"},
  {value: "America/Inuvik", label: "America/Inuvik", text: "America/Inuvik"},
  {value: "America/Iqaluit", label: "America/Iqaluit", text: "America/Iqaluit"},
  {value: "America/Jamaica", label: "America/Jamaica", text: "America/Jamaica"},
  {value: "America/Juneau", label: "America/Juneau", text: "America/Juneau"},
  {value: "America/Kentucky/Louisville", label: "America/Kentucky/Louisville", text: "America/Kentucky/Louisville"},
  {value: "America/Kentucky/Monticello", label: "America/Kentucky/Monticello", text: "America/Kentucky/Monticello"},
  {value: "America/Kralendijk", label: "America/Kralendijk", text: "America/Kralendijk"},
  {value: "America/La_Paz", label: "America/La_Paz", text: "America/La_Paz"},
  {value: "America/Lima", label: "America/Lima", text: "America/Lima"},
  {value: "America/Los_Angeles", label: "America/Los_Angeles", text: "America/Los_Angeles"},
  {value: "America/Lower_Princes", label: "America/Lower_Princes", text: "America/Lower_Princes"},
  {value: "America/Maceio", label: "America/Maceio", text: "America/Maceio"},
  {value: "America/Managua", label: "America/Managua", text: "America/Managua"},
  {value: "America/Manaus", label: "America/Manaus", text: "America/Manaus"},
  {value: "America/Marigot", label: "America/Marigot", text: "America/Marigot"},
  {value: "America/Martinique", label: "America/Martinique", text: "America/Martinique"},
  {value: "America/Matamoros", label: "America/Matamoros", text: "America/Matamoros"},
  {value: "America/Mazatlan", label: "America/Mazatlan", text: "America/Mazatlan"},
  {value: "America/Menominee", label: "America/Menominee", text: "America/Menominee"},
  {value: "America/Merida", label: "America/Merida", text: "America/Merida"},
  {value: "America/Metlakatla", label: "America/Metlakatla", text: "America/Metlakatla"},
  {value: "America/Mexico_City", label: "America/Mexico_City", text: "America/Mexico_City"},
  {value: "America/Miquelon", label: "America/Miquelon", text: "America/Miquelon"},
  {value: "America/Moncton", label: "America/Moncton", text: "America/Moncton"},
  {value: "America/Monterrey", label: "America/Monterrey", text: "America/Monterrey"},
  {value: "America/Montevideo", label: "America/Montevideo", text: "America/Montevideo"},
  {value: "America/Montserrat", label: "America/Montserrat", text: "America/Montserrat"},
  {value: "America/Nassau", label: "America/Nassau", text: "America/Nassau"},
  {value: "America/New_York", label: "America/New_York", text: "America/New_York"},
  {value: "America/Nipigon", label: "America/Nipigon", text: "America/Nipigon"},
  {value: "America/Nome", label: "America/Nome", text: "America/Nome"},
  {value: "America/Noronha", label: "America/Noronha", text: "America/Noronha"},
  {value: "America/North_Dakota/Beulah", label: "America/North_Dakota/Beulah", text: "America/North_Dakota/Beulah"},
  {value: "America/North_Dakota/Center", label: "America/North_Dakota/Center", text: "America/North_Dakota/Center"},
  {value: "America/North_Dakota/New_Salem", label: "America/North_Dakota/New_Salem", text: "America/North_Dakota/New_Salem"},
  {value: "America/Ojinaga", label: "America/Ojinaga", text: "America/Ojinaga"},
  {value: "America/Panama", label: "America/Panama", text: "America/Panama"},
  {value: "America/Pangnirtung", label: "America/Pangnirtung", text: "America/Pangnirtung"},
  {value: "America/Paramaribo", label: "America/Paramaribo", text: "America/Paramaribo"},
  {value: "America/Phoenix", label: "America/Phoenix", text: "America/Phoenix"},
  {value: "America/Port-au-Prince", label: "America/Port-au-Prince", text: "America/Port-au-Prince"},
  {value: "America/Port_of_Spain", label: "America/Port_of_Spain", text: "America/Port_of_Spain"},
  {value: "America/Porto_Velho", label: "America/Porto_Velho", text: "America/Porto_Velho"},
  {value: "America/Puerto_Rico", label: "America/Puerto_Rico", text: "America/Puerto_Rico"},
  {value: "America/Punta_Arenas", label: "America/Punta_Arenas", text: "America/Punta_Arenas"},
  {value: "America/Rainy_River", label: "America/Rainy_River", text: "America/Rainy_River"},
  {value: "America/Rankin_Inlet", label: "America/Rankin_Inlet", text: "America/Rankin_Inlet"},
  {value: "America/Recife", label: "America/Recife", text: "America/Recife"},
  {value: "America/Regina", label: "America/Regina", text: "America/Regina"},
  {value: "America/Resolute", label: "America/Resolute", text: "America/Resolute"},
  {value: "America/Rio_Branco", label: "America/Rio_Branco", text: "America/Rio_Branco"},
  {value: "America/Santarem", label: "America/Santarem", text: "America/Santarem"},
  {value: "America/Santiago", label: "America/Santiago", text: "America/Santiago"},
  {value: "America/Santo_Domingo", label: "America/Santo_Domingo", text: "America/Santo_Domingo"},
  {value: "America/Sao_Paulo", label: "America/Sao_Paulo", text: "America/Sao_Paulo"},
  {value: "America/Scoresbysund", label: "America/Scoresbysund", text: "America/Scoresbysund"},
  {value: "America/Sitka", label: "America/Sitka", text: "America/Sitka"},
  {value: "America/St_Barthelemy", label: "America/St_Barthelemy", text: "America/St_Barthelemy"},
  {value: "America/St_Johns", label: "America/St_Johns", text: "America/St_Johns"},
  {value: "America/St_Kitts", label: "America/St_Kitts", text: "America/St_Kitts"},
  {value: "America/St_Lucia", label: "America/St_Lucia", text: "America/St_Lucia"},
  {value: "America/St_Thomas", label: "America/St_Thomas", text: "America/St_Thomas"},
  {value: "America/St_Vincent", label: "America/St_Vincent", text: "America/St_Vincent"},
  {value: "America/Swift_Current", label: "America/Swift_Current", text: "America/Swift_Current"},
  {value: "America/Tegucigalpa", label: "America/Tegucigalpa", text: "America/Tegucigalpa"},
  {value: "America/Thule", label: "America/Thule", text: "America/Thule"},
  {value: "America/Thunder_Bay", label: "America/Thunder_Bay", text: "America/Thunder_Bay"},
  {value: "America/Tijuana", label: "America/Tijuana", text: "America/Tijuana"},
  {value: "America/Toronto", label: "America/Toronto", text: "America/Toronto"},
  {value: "America/Tortola", label: "America/Tortola", text: "America/Tortola"},
  {value: "America/Vancouver", label: "America/Vancouver", text: "America/Vancouver"},
  {value: "America/Whitehorse", label: "America/Whitehorse", text: "America/Whitehorse"},
  {value: "America/Winnipeg", label: "America/Winnipeg", text: "America/Winnipeg"},
  {value: "America/Yakutat", label: "America/Yakutat", text: "America/Yakutat"},
  {value: "America/Yellowknife", label: "America/Yellowknife", text: "America/Yellowknife"},
  {value: "Antarctica/Casey", label: "Antarctica/Casey", text: "Antarctica/Casey"},
  {value: "Antarctica/Davis", label: "Antarctica/Davis", text: "Antarctica/Davis"},
  {value: "Antarctica/DumontDUrville", label: "Antarctica/DumontDUrville", text: "Antarctica/DumontDUrville"},
  {value: "Antarctica/Macquarie", label: "Antarctica/Macquarie", text: "Antarctica/Macquarie"},
  {value: "Antarctica/Mawson", label: "Antarctica/Mawson", text: "Antarctica/Mawson"},
  {value: "Antarctica/McMurdo", label: "Antarctica/McMurdo", text: "Antarctica/McMurdo"},
  {value: "Antarctica/Palmer", label: "Antarctica/Palmer", text: "Antarctica/Palmer"},
  {value: "Antarctica/Rothera", label: "Antarctica/Rothera", text: "Antarctica/Rothera"},
  {value: "Antarctica/Syowa", label: "Antarctica/Syowa", text: "Antarctica/Syowa"},
  {value: "Antarctica/Troll", label: "Antarctica/Troll", text: "Antarctica/Troll"},
  {value: "Antarctica/Vostok", label: "Antarctica/Vostok", text: "Antarctica/Vostok"},
  {value: "Arctic/Longyearbyen", label: "Arctic/Longyearbyen", text: "Arctic/Longyearbyen"},
  {value: "Asia/Aden", label: "Asia/Aden", text: "Asia/Aden"},
  {value: "Asia/Almaty", label: "Asia/Almaty", text: "Asia/Almaty"},
  {value: "Asia/Amman", label: "Asia/Amman", text: "Asia/Amman"},
  {value: "Asia/Anadyr", label: "Asia/Anadyr", text: "Asia/Anadyr"},
  {value: "Asia/Aqtau", label: "Asia/Aqtau", text: "Asia/Aqtau"},
  {value: "Asia/Aqtobe", label: "Asia/Aqtobe", text: "Asia/Aqtobe"},
  {value: "Asia/Ashgabat", label: "Asia/Ashgabat", text: "Asia/Ashgabat"},
  {value: "Asia/Atyrau", label: "Asia/Atyrau", text: "Asia/Atyrau"},
  {value: "Asia/Baghdad", label: "Asia/Baghdad", text: "Asia/Baghdad"},
  {value: "Asia/Bahrain", label: "Asia/Bahrain", text: "Asia/Bahrain"},
  {value: "Asia/Baku", label: "Asia/Baku", text: "Asia/Baku"},
  {value: "Asia/Bangkok", label: "Asia/Bangkok", text: "Asia/Bangkok"},
  {value: "Asia/Barnaul", label: "Asia/Barnaul", text: "Asia/Barnaul"},
  {value: "Asia/Beirut", label: "Asia/Beirut", text: "Asia/Beirut"},
  {value: "Asia/Bishkek", label: "Asia/Bishkek", text: "Asia/Bishkek"},
  {value: "Asia/Brunei", label: "Asia/Brunei", text: "Asia/Brunei"},
  {value: "Asia/Chita", label: "Asia/Chita", text: "Asia/Chita"},
  {value: "Asia/Choibalsan", label: "Asia/Choibalsan", text: "Asia/Choibalsan"},
  {value: "Asia/Colombo", label: "Asia/Colombo", text: "Asia/Colombo"},
  {value: "Asia/Damascus", label: "Asia/Damascus", text: "Asia/Damascus"},
  {value: "Asia/Dhaka", label: "Asia/Dhaka", text: "Asia/Dhaka"},
  {value: "Asia/Dili", label: "Asia/Dili", text: "Asia/Dili"},
  {value: "Asia/Dubai", label: "Asia/Dubai", text: "Asia/Dubai"},
  {value: "Asia/Dushanbe", label: "Asia/Dushanbe", text: "Asia/Dushanbe"},
  {value: "Asia/Famagusta", label: "Asia/Famagusta", text: "Asia/Famagusta"},
  {value: "Asia/Gaza", label: "Asia/Gaza", text: "Asia/Gaza"},
  {value: "Asia/Hebron", label: "Asia/Hebron", text: "Asia/Hebron"},
  {value: "Asia/Ho_Chi_Minh", label: "Asia/Ho_Chi_Minh", text: "Asia/Ho_Chi_Minh"},
  {value: "Asia/Hong_Kong", label: "Asia/Hong_Kong", text: "Asia/Hong_Kong"},
  {value: "Asia/Hovd", label: "Asia/Hovd", text: "Asia/Hovd"},
  {value: "Asia/Irkutsk", label: "Asia/Irkutsk", text: "Asia/Irkutsk"},
  {value: "Asia/Jakarta", label: "Asia/Jakarta", text: "Asia/Jakarta"},
  {value: "Asia/Jayapura", label: "Asia/Jayapura", text: "Asia/Jayapura"},
  {value: "Asia/Jerusalem", label: "Asia/Jerusalem", text: "Asia/Jerusalem"},
  {value: "Asia/Kabul", label: "Asia/Kabul", text: "Asia/Kabul"},
  {value: "Asia/Kamchatka", label: "Asia/Kamchatka", text: "Asia/Kamchatka"},
  {value: "Asia/Karachi", label: "Asia/Karachi", text: "Asia/Karachi"},
  {value: "Asia/Kathmandu", label: "Asia/Kathmandu", text: "Asia/Kathmandu"},
  {value: "Asia/Khandyga", label: "Asia/Khandyga", text: "Asia/Khandyga"},
  {value: "Asia/Kolkata", label: "Asia/Kolkata", text: "Asia/Kolkata"},
  {value: "Asia/Krasnoyarsk", label: "Asia/Krasnoyarsk", text: "Asia/Krasnoyarsk"},
  {value: "Asia/Kuala_Lumpur", label: "Asia/Kuala_Lumpur", text: "Asia/Kuala_Lumpur"},
  {value: "Asia/Kuching", label: "Asia/Kuching", text: "Asia/Kuching"},
  {value: "Asia/Kuwait", label: "Asia/Kuwait", text: "Asia/Kuwait"},
  {value: "Asia/Macau", label: "Asia/Macau", text: "Asia/Macau"},
  {value: "Asia/Magadan", label: "Asia/Magadan", text: "Asia/Magadan"},
  {value: "Asia/Makassar", label: "Asia/Makassar", text: "Asia/Makassar"},
  {value: "Asia/Manila", label: "Asia/Manila", text: "Asia/Manila"},
  {value: "Asia/Muscat", label: "Asia/Muscat", text: "Asia/Muscat"},
  {value: "Asia/Nicosia", label: "Asia/Nicosia", text: "Asia/Nicosia"},
  {value: "Asia/Novokuznetsk", label: "Asia/Novokuznetsk", text: "Asia/Novokuznetsk"},
  {value: "Asia/Novosibirsk", label: "Asia/Novosibirsk", text: "Asia/Novosibirsk"},
  {value: "Asia/Omsk", label: "Asia/Omsk", text: "Asia/Omsk"},
  {value: "Asia/Oral", label: "Asia/Oral", text: "Asia/Oral"},
  {value: "Asia/Phnom_Penh", label: "Asia/Phnom_Penh", text: "Asia/Phnom_Penh"},
  {value: "Asia/Pontianak", label: "Asia/Pontianak", text: "Asia/Pontianak"},
  {value: "Asia/Pyongyang", label: "Asia/Pyongyang", text: "Asia/Pyongyang"},
  {value: "Asia/Qatar", label: "Asia/Qatar", text: "Asia/Qatar"},
  {value: "Asia/Qostanay", label: "Asia/Qostanay", text: "Asia/Qostanay"},
  {value: "Asia/Qyzylorda", label: "Asia/Qyzylorda", text: "Asia/Qyzylorda"},
  {value: "Asia/Riyadh", label: "Asia/Riyadh", text: "Asia/Riyadh"},
  {value: "Asia/Sakhalin", label: "Asia/Sakhalin", text: "Asia/Sakhalin"},
  {value: "Asia/Samarkand", label: "Asia/Samarkand", text: "Asia/Samarkand"},
  {value: "Asia/Seoul", label: "Asia/Seoul", text: "Asia/Seoul"},
  {value: "Asia/Shanghai", label: "Asia/Shanghai", text: "Asia/Shanghai"},
  {value: "Asia/Singapore", label: "Asia/Singapore", text: "Asia/Singapore"},
  {value: "Asia/Srednekolymsk", label: "Asia/Srednekolymsk", text: "Asia/Srednekolymsk"},
  {value: "Asia/Taipei", label: "Asia/Taipei", text: "Asia/Taipei"},
  {value: "Asia/Tashkent", label: "Asia/Tashkent", text: "Asia/Tashkent"},
  {value: "Asia/Tbilisi", label: "Asia/Tbilisi", text: "Asia/Tbilisi"},
  {value: "Asia/Tehran", label: "Asia/Tehran", text: "Asia/Tehran"},
  {value: "Asia/Thimphu", label: "Asia/Thimphu", text: "Asia/Thimphu"},
  {value: "Asia/Tokyo", label: "Asia/Tokyo", text: "Asia/Tokyo"},
  {value: "Asia/Tomsk", label: "Asia/Tomsk", text: "Asia/Tomsk"},
  {value: "Asia/Ulaanbaatar", label: "Asia/Ulaanbaatar", text: "Asia/Ulaanbaatar"},
  {value: "Asia/Urumqi", label: "Asia/Urumqi", text: "Asia/Urumqi"},
  {value: "Asia/Ust-Nera", label: "Asia/Ust-Nera", text: "Asia/Ust-Nera"},
  {value: "Asia/Vientiane", label: "Asia/Vientiane", text: "Asia/Vientiane"},
  {value: "Asia/Vladivostok", label: "Asia/Vladivostok", text: "Asia/Vladivostok"},
  {value: "Asia/Yakutsk", label: "Asia/Yakutsk", text: "Asia/Yakutsk"},
  {value: "Asia/Yangon", label: "Asia/Yangon", text: "Asia/Yangon"},
  {value: "Asia/Yekaterinburg", label: "Asia/Yekaterinburg", text: "Asia/Yekaterinburg"},
  {value: "Asia/Yerevan", label: "Asia/Yerevan", text: "Asia/Yerevan"},
  {value: "Atlantic/Azores", label: "Atlantic/Azores", text: "Atlantic/Azores"},
  {value: "Atlantic/Bermuda", label: "Atlantic/Bermuda", text: "Atlantic/Bermuda"},
  {value: "Atlantic/Canary", label: "Atlantic/Canary", text: "Atlantic/Canary"},
  {value: "Atlantic/Cape_Verde", label: "Atlantic/Cape_Verde", text: "Atlantic/Cape_Verde"},
  {value: "Atlantic/Faroe", label: "Atlantic/Faroe", text: "Atlantic/Faroe"},
  {value: "Atlantic/Madeira", label: "Atlantic/Madeira", text: "Atlantic/Madeira"},
  {value: "Atlantic/Reykjavik", label: "Atlantic/Reykjavik", text: "Atlantic/Reykjavik"},
  {value: "Atlantic/South_Georgia", label: "Atlantic/South_Georgia", text: "Atlantic/South_Georgia"},
  {value: "Atlantic/St_Helena", label: "Atlantic/St_Helena", text: "Atlantic/St_Helena"},
  {value: "Atlantic/Stanley", label: "Atlantic/Stanley", text: "Atlantic/Stanley"},
  {value: "Australia/Adelaide", label: "Australia/Adelaide", text: "Australia/Adelaide"},
  {value: "Australia/Brisbane", label: "Australia/Brisbane", text: "Australia/Brisbane"},
  {value: "Australia/Broken_Hill", label: "Australia/Broken_Hill", text: "Australia/Broken_Hill"},
  {value: "Australia/Currie", label: "Australia/Currie", text: "Australia/Currie"},
  {value: "Australia/Darwin", label: "Australia/Darwin", text: "Australia/Darwin"},
  {value: "Australia/Eucla", label: "Australia/Eucla", text: "Australia/Eucla"},
  {value: "Australia/Hobart", label: "Australia/Hobart", text: "Australia/Hobart"},
  {value: "Australia/Lindeman", label: "Australia/Lindeman", text: "Australia/Lindeman"},
  {value: "Australia/Lord_Howe", label: "Australia/Lord_Howe", text: "Australia/Lord_Howe"},
  {value: "Australia/Melbourne", label: "Australia/Melbourne", text: "Australia/Melbourne"},
  {value: "Australia/Perth", label: "Australia/Perth", text: "Australia/Perth"},
  {value: "Australia/Sydney", label: "Australia/Sydney", text: "Australia/Sydney"},
  {value: "Canada/Atlantic", label: "Canada/Atlantic", text: "Canada/Atlantic"},
  {value: "Canada/Central", label: "Canada/Central", text: "Canada/Central"},
  {value: "Canada/Eastern", label: "Canada/Eastern", text: "Canada/Eastern"},
  {value: "Canada/Mountain", label: "Canada/Mountain", text: "Canada/Mountain"},
  {value: "Canada/Newfoundland", label: "Canada/Newfoundland", text: "Canada/Newfoundland"},
  {value: "Canada/Pacific", label: "Canada/Pacific", text: "Canada/Pacific"},
  {value: "Europe/Amsterdam", label: "Europe/Amsterdam", text: "Europe/Amsterdam"},
  {value: "Europe/Andorra", label: "Europe/Andorra", text: "Europe/Andorra"},
  {value: "Europe/Astrakhan", label: "Europe/Astrakhan", text: "Europe/Astrakhan"},
  {value: "Europe/Athens", label: "Europe/Athens", text: "Europe/Athens"},
  {value: "Europe/Belgrade", label: "Europe/Belgrade", text: "Europe/Belgrade"},
  {value: "Europe/Berlin", label: "Europe/Berlin", text: "Europe/Berlin"},
  {value: "Europe/Bratislava", label: "Europe/Bratislava", text: "Europe/Bratislava"},
  {value: "Europe/Brussels", label: "Europe/Brussels", text: "Europe/Brussels"},
  {value: "Europe/Bucharest", label: "Europe/Bucharest", text: "Europe/Bucharest"},
  {value: "Europe/Budapest", label: "Europe/Budapest", text: "Europe/Budapest"},
  {value: "Europe/Busingen", label: "Europe/Busingen", text: "Europe/Busingen"},
  {value: "Europe/Chisinau", label: "Europe/Chisinau", text: "Europe/Chisinau"},
  {value: "Europe/Copenhagen", label: "Europe/Copenhagen", text: "Europe/Copenhagen"},
  {value: "Europe/Dublin", label: "Europe/Dublin", text: "Europe/Dublin"},
  {value: "Europe/Gibraltar", label: "Europe/Gibraltar", text: "Europe/Gibraltar"},
  {value: "Europe/Guernsey", label: "Europe/Guernsey", text: "Europe/Guernsey"},
  {value: "Europe/Helsinki", label: "Europe/Helsinki", text: "Europe/Helsinki"},
  {value: "Europe/Isle_of_Man", label: "Europe/Isle_of_Man", text: "Europe/Isle_of_Man"},
  {value: "Europe/Istanbul", label: "Europe/Istanbul", text: "Europe/Istanbul"},
  {value: "Europe/Jersey", label: "Europe/Jersey", text: "Europe/Jersey"},
  {value: "Europe/Kaliningrad", label: "Europe/Kaliningrad", text: "Europe/Kaliningrad"},
  {value: "Europe/Kiev", label: "Europe/Kiev", text: "Europe/Kiev"},
  {value: "Europe/Kirov", label: "Europe/Kirov", text: "Europe/Kirov"},
  {value: "Europe/Lisbon", label: "Europe/Lisbon", text: "Europe/Lisbon"},
  {value: "Europe/Ljubljana", label: "Europe/Ljubljana", text: "Europe/Ljubljana"},
  {value: "Europe/London", label: "Europe/London", text: "Europe/London"},
  {value: "Europe/Luxembourg", label: "Europe/Luxembourg", text: "Europe/Luxembourg"},
  {value: "Europe/Madrid", label: "Europe/Madrid", text: "Europe/Madrid"},
  {value: "Europe/Malta", label: "Europe/Malta", text: "Europe/Malta"},
  {value: "Europe/Mariehamn", label: "Europe/Mariehamn", text: "Europe/Mariehamn"},
  {value: "Europe/Minsk", label: "Europe/Minsk", text: "Europe/Minsk"},
  {value: "Europe/Monaco", label: "Europe/Monaco", text: "Europe/Monaco"},
  {value: "Europe/Moscow", label: "Europe/Moscow", text: "Europe/Moscow"},
  {value: "Europe/Oslo", label: "Europe/Oslo", text: "Europe/Oslo"},
  {value: "Europe/Paris", label: "Europe/Paris", text: "Europe/Paris"},
  {value: "Europe/Podgorica", label: "Europe/Podgorica", text: "Europe/Podgorica"},
  {value: "Europe/Prague", label: "Europe/Prague", text: "Europe/Prague"},
  {value: "Europe/Riga", label: "Europe/Riga", text: "Europe/Riga"},
  {value: "Europe/Rome", label: "Europe/Rome", text: "Europe/Rome"},
  {value: "Europe/Samara", label: "Europe/Samara", text: "Europe/Samara"},
  {value: "Europe/San_Marino", label: "Europe/San_Marino", text: "Europe/San_Marino"},
  {value: "Europe/Sarajevo", label: "Europe/Sarajevo", text: "Europe/Sarajevo"},
  {value: "Europe/Saratov", label: "Europe/Saratov", text: "Europe/Saratov"},
  {value: "Europe/Simferopol", label: "Europe/Simferopol", text: "Europe/Simferopol"},
  {value: "Europe/Skopje", label: "Europe/Skopje", text: "Europe/Skopje"},
  {value: "Europe/Sofia", label: "Europe/Sofia", text: "Europe/Sofia"},
  {value: "Europe/Stockholm", label: "Europe/Stockholm", text: "Europe/Stockholm"},
  {value: "Europe/Tallinn", label: "Europe/Tallinn", text: "Europe/Tallinn"},
  {value: "Europe/Tirane", label: "Europe/Tirane", text: "Europe/Tirane"},
  {value: "Europe/Ulyanovsk", label: "Europe/Ulyanovsk", text: "Europe/Ulyanovsk"},
  {value: "Europe/Uzhgorod", label: "Europe/Uzhgorod", text: "Europe/Uzhgorod"},
  {value: "Europe/Vaduz", label: "Europe/Vaduz", text: "Europe/Vaduz"},
  {value: "Europe/Vatican", label: "Europe/Vatican", text: "Europe/Vatican"},
  {value: "Europe/Vienna", label: "Europe/Vienna", text: "Europe/Vienna"},
  {value: "Europe/Vilnius", label: "Europe/Vilnius", text: "Europe/Vilnius"},
  {value: "Europe/Volgograd", label: "Europe/Volgograd", text: "Europe/Volgograd"},
  {value: "Europe/Warsaw", label: "Europe/Warsaw", text: "Europe/Warsaw"},
  {value: "Europe/Zagreb", label: "Europe/Zagreb", text: "Europe/Zagreb"},
  {value: "Europe/Zaporozhye", label: "Europe/Zaporozhye", text: "Europe/Zaporozhye"},
  {value: "Europe/Zurich", label: "Europe/Zurich", text: "Europe/Zurich"},
  {value: "GMT", label: "GMT",text: "GMT" },
  {value: "Indian/Antananarivo", label: "Indian/Antananarivo",text: "Indian/Antananarivo" },
  {value: "Indian/Chagos", label: "Indian/Chagos", text: "Indian/Chagos"},
  {value: "Indian/Christmas", label: "Indian/Christmas", text: "Indian/Christmas"},
  {value: "Indian/Cocos", label: "Indian/Cocos", text: "Indian/Cocos"},
  {value: "Indian/Comoro", label: "Indian/Comoro", text: "Indian/Comoro"},
  {value: "Indian/Kerguelen", label: "Indian/Kerguelen", text: "Indian/Kerguelen"},
  {value: "Indian/Mahe", label: "Indian/Mahe", text: "Indian/Mahe"},
  {value: "Indian/Maldives", label: "Indian/Maldives", text: "Indian/Maldives"},
  {value: "Indian/Mauritius", label: "Indian/Mauritius", text: "Indian/Mauritius"},
  {value: "Indian/Mayotte", label: "Indian/Mayotte", text: "Indian/Mayotte"},
  {value: "Indian/Reunion", label: "Indian/Reunion", text: "Indian/Reunion"},
  {value: "Pacific/Apia", label: "Pacific/Apia", text: "Pacific/Apia"},
  {value: "Pacific/Auckland", label: "Pacific/Auckland", text: "Pacific/Auckland"},
  {value: "Pacific/Bougainville", label: "Pacific/Bougainville", text: "Pacific/Bougainville"},
  {value: "Pacific/Chatham", label: "Pacific/Chatham", text: "Pacific/Chatham"},
  {value: "Pacific/Chuuk", label: "Pacific/Chuuk", text: "Pacific/Chuuk"},
  {value: "Pacific/Easter", label: "Pacific/Easter", text: "Pacific/Easter"},
  {value: "Pacific/Efate", label: "Pacific/Efate", text: "Pacific/Efate"},
  {value: "Pacific/Enderbury", label: "Pacific/Enderbury", text: "Pacific/Enderbury"},
  {value: "Pacific/Fakaofo", label: "Pacific/Fakaofo", text: "Pacific/Fakaofo"},
  {value: "Pacific/Fiji", label: "Pacific/Fiji", text: "Pacific/Fiji"},
  {value: "Pacific/Funafuti", label: "Pacific/Funafuti", text: "Pacific/Funafuti"},
  {value: "Pacific/Galapagos", label: "Pacific/Galapagos", text: "Pacific/Galapagos"},
  {value: "Pacific/Gambier", label: "Pacific/Gambier", text: "Pacific/Gambier"},
  {value: "Pacific/Guadalcanal", label: "Pacific/Guadalcanal", text: "Pacific/Guadalcanal"},
  {value: "Pacific/Guam", label: "Pacific/Guam", text: "Pacific/Guam"},
  {value: "Pacific/Honolulu", label: "Pacific/Honolulu", text: "Pacific/Honolulu"},
  {value: "Pacific/Kiritimati", label: "Pacific/Kiritimati", text: "Pacific/Kiritimati"},
  {value: "Pacific/Kosrae", label: "Pacific/Kosrae", text: "Pacific/Kosrae"},
  {value: "Pacific/Kwajalein", label: "Pacific/Kwajalein", text: "Pacific/Kwajalein"},
  {value: "Pacific/Majuro", label: "Pacific/Majuro", text: "Pacific/Majuro"},
  {value: "Pacific/Marquesas", label: "Pacific/Marquesas", text: "Pacific/Marquesas"},
  {value: "Pacific/Midway", label: "Pacific/Midway", text: "Pacific/Midway"},
  {value: "Pacific/Nauru", label: "Pacific/Nauru", text: "Pacific/Nauru"},
  {value: "Pacific/Niue", label: "Pacific/Niue", text: "Pacific/Niue"},
  {value: "Pacific/Norfolk", label: "Pacific/Norfolk", text: "Pacific/Norfolk"},
  {value: "Pacific/Noumea", label: "Pacific/Noumea", text: "Pacific/Noumea"},
  {value: "Pacific/Pago_Pago", label: "Pacific/Pago_Pago", text: "Pacific/Pago_Pago"},
  {value: "Pacific/Palau", label: "Pacific/Palau", text: "Pacific/Palau"},
  {value: "Pacific/Pitcairn", label: "Pacific/Pitcairn", text: "Pacific/Pitcairn"},
  {value: "Pacific/Pohnpei", label: "Pacific/Pohnpei", text: "Pacific/Pohnpei"},
  {value: "Pacific/Port_Moresby", label: "Pacific/Port_Moresby", text: "Pacific/Port_Moresby"},
  {value: "Pacific/Rarotonga", label: "Pacific/Rarotonga", text: "Pacific/Rarotonga"},
  {value: "Pacific/Saipan", label: "Pacific/Saipan", text: "Pacific/Saipan"},
  {value: "Pacific/Tahiti", label: "Pacific/Tahiti", text: "Pacific/Tahiti"},
  {value: "Pacific/Tarawa", label: "Pacific/Tarawa", text: "Pacific/Tarawa"},
  {value: "Pacific/Tongatapu", label: "Pacific/Tongatapu", text: "Pacific/Tongatapu"},
  {value: "Pacific/Wake", label: "Pacific/Wake", text: "Pacific/Wake"},
  {value: "Pacific/Wallis", label: "Pacific/Wallis", text: "Pacific/Wallis"},
  {value: "US/Alaska", label: "US/Alaska", text: "US/Alaska"},
  {value: "US/Arizona", label: "US/Arizona", text: "US/Arizona"},
  {value: "US/Central", label: "US/Central", text: "US/Central"},
  {value: "US/Eastern", label: "US/Eastern", text: "US/Eastern"},
  {value: "US/Hawaii", label: "US/Hawaii", text: "US/Hawaii"},
  {value: "US/Mountain", label: "US/Mountain", text: "US/Mountain"},
  {value: "US/Pacific", label: "US/Pacific", text: "US/Pacific"},
  {value: "UTC", label: "UTC", text: "UTC"}
];
